import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Add as AddIcon } from '@mui/icons-material';
import { Divider } from '@weave-mui/material';

import PageTitle from 'components/PageTitle';
import TestSuitesDataGrid from 'components/TestSuitesDataGrid';
import Button, { buttonVariants, buttonTargets } from '@weave-mui/button';
import WeaveMuiThemeProvider from 'components/WeaveMuiThemeProvider';

import { getAllTestSuites } from 'store/actions/test_suites_actions';

const TestSuites = () => {
  const [loadingTestSuites, setLoadingTestSuites] = useState(true);

  const dispatch = useDispatch();

  const categories = useSelector((state) => state.menu.categories);
  const userInfo = useSelector((state) => state.app.userInfo);
  const suites = useSelector((state) => state.testSuites.suites);
  const roles = useSelector((state) => state.testSuites.roles);

  useEffect(() => {
    const validServices = ['thservices', 'projects'];
    const invalidCategories = ['testdata', 'Perf testing'];

    if (suites.length === 0) {
      setLoadingTestSuites(true);
    }

    // removing not supported categories
    const services = validServices
      .reduce((accumulator, currentCategory) => {
        return [...accumulator, ...categories[currentCategory]];
      }, [])
      .filter((category) => !invalidCategories.includes(category.servicename))
      .map((category) => {
        if (!category.servicename) {
          category.servicename = category.name;
        }

        return category;
      });

    dispatch(getAllTestSuites(services)).then(() => {
      setLoadingTestSuites(false);
    });
  }, []);

  // Check if there are any test suites to conditionally show the button
  const hasTestSuites =
    suites &&
    suites.length > 0 &&
    suites.some(
      (service) => service.testsuites && service.testsuites.length > 0
    );

  return (
    <WeaveMuiThemeProvider>
      <div className="testsuites-wrapper">
        <PageTitle
          title="Test suites"
          description="Test suites give you the freedom to trigger different set of tests at the press of a button."
        >
          {hasTestSuites && (
            <Button
              href="/testsuites/new"
              variant={buttonVariants.CONTAINED}
              target={buttonTargets.SELF}
              startIcon={<AddIcon />}
              sx={{
                backgroundColor: '#000000 !important',
                color: '#ffffff !important',
                '&:hover': {
                  backgroundColor: '#333333 !important',
                },
                '&.MuiButton-contained': {
                  backgroundColor: '#000000 !important',
                  color: '#ffffff !important',
                },
                '&.MuiButton-contained:hover': {
                  backgroundColor: '#333333 !important',
                },
                fontSize: '14px',
                lineHeight: '18px',
                padding: '4px 12px',
                borderRadius: '4px',
                width: '186px',
                height: '32px',
                '& .MuiButton-startIcon': {
                  margin: '0 !important',
                },
              }}
            >
              Create a new test suite
            </Button>
          )}
        </PageTitle>

        <Divider
          sx={{
            backgroundColor: 'rgba(0, 0, 0, 0.1)',
            height: '1px',
            border: 'none',
            my: 1,
            marginTop: '0px',
          }}
        />

        <TestSuitesDataGrid
          suites={suites}
          roles={roles}
          userInfo={userInfo}
          loadingTestSuites={loadingTestSuites}
        />
      </div>
    </WeaveMuiThemeProvider>
  );
};
export default TestSuites;
